import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// Billing is now combined with Account Management
// This component redirects to the unified Account & Billing page
const Billing = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/dashboard/account-management', { replace: true });
  }, [navigate]);

  return null;
};

export default Billing;
